"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryPickupRouteUpdate = exports.DeliveryPickupRouteCreate = exports.DeliveryPickupRouteQuery = exports.DeliveryPickupRouteTransport = exports.DeliveryPickupRoute = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const DeliveryPickupPlannedStop_1 = require("./DeliveryPickupPlannedStop");
const DeliveryPickupRouteBreadcrumb_1 = require("./DeliveryPickupRouteBreadcrumb");
exports.DeliveryPickupRoute = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    driverID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    scheduledDate: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'date' })),
    started: typebox_1.Type.Boolean(),
    completed: typebox_1.Type.Boolean(),
    deliveryPickupPlannedStops: typebox_1.Type.Array(DeliveryPickupPlannedStop_1.DeliveryPickupPlannedStop),
    deliveryPickupBreadcrumbs: typebox_1.Type.Array(DeliveryPickupRouteBreadcrumb_1.DeliveryPickupRouteBreadcrumb),
    metadata: common_1.MetaData,
});
exports.DeliveryPickupRouteTransport = exports.DeliveryPickupRoute;
exports.DeliveryPickupRouteQuery = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    common_1.BaseQuery,
    typebox_1.Type.Object({
        scheduleDate: typebox_1.Type.String({ format: 'date' }),
        driverID: typebox_1.Type.String({ format: 'uuid' }),
    }),
]));
exports.DeliveryPickupRouteCreate = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupRoute, [
        'id',
        'haulerID',
        'deliveryPickupPlannedStops',
        'started',
        'deliveryPickupBreadcrumbs',
        'metadata',
        'completed',
    ]),
    typebox_1.Type.Object({
        // started: cannot be set on create, will always start off as false
        plannedStopsIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    }),
]);
exports.DeliveryPickupRouteUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.DeliveryPickupRoute, [
        'id',
        'haulerID',
        'scheduledDate',
        'deliveryPickupPlannedStops',
        'deliveryPickupBreadcrumbs',
        'metadata',
    ]),
    typebox_1.Type.Object({
        scheduledDate: (0, common_1.Nullable)(typebox_1.Type.String({ format: 'date' })),
        deliveryPickupPlannedStopIDs: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    }),
]));
//# sourceMappingURL=DeliveryPickupRoute.js.map